export enum StatSource {
  WEB = 'WEB',
  EPHZHB = 'EPHZHB',
  OTP_BANK = 'OTP_BANK',
}

export interface StatLocationStatistics {
  annualCO2Reduction: string;
  investment: string;
  investmentReturn: string;
  systemCapacity: string;
  source: StatSource | null;
  time: string | null;
  userContact: string | null;
  omm: string | null;
  tariffGroup: string | null;
}

export interface StatLocation {
  lat: string;
  lng: string;
  statistics: StatLocationStatistics[];
}

export interface StatData {
  numberAnalysis: number;
  numberUniqueLocationAnalysis: number;
  numberPaymentAnalysis: number;
  numberActiveSubscriber: number;
  numberRegisterUser: number;
  numberHistoryVisitor: number;
  analysisLocation: StatLocation[];
}
